// 埋点文件, 本文件埋点只做事件为浏览时候的埋点
// 如果其他事件, 请在代码里自行添加

import utils from './utils'

// track._launch(页面层级id, 上报类型, 事件id, 上报参数);
export default function track(route) {
  switch (route.name) {
    // case 'product-detail':
    //     utils.tracker('100101', '10000', 11000, route.params.spuId, route.query.entity_id, route.query.channel_id);
    //     break;
    case 'product-confirm':
      // utils.tracker('110101', '10000', 11006)
      break
    case 'comments':
      utils.tracker('100101', '10000', 11005)
      break
    case 'comment-add':
      utils.tracker('110802', '10000', 11016, route.params.orderCode)
      break
    // case 'worker':
    //     utils.tracker('130201', '10000', 11019, route.query.cityname, route.params.serviceType);
    //     break;
    case 'comment-success':
      utils.tracker('110803', '10000', 11020, route.params.orderCode)
      utils.trackerBT(121012486)()
      break
    case 'comment-share':
      utils.tracker('110804', '10000', 11021)
      utils.trackerBT(121012488)()
      break
    case 'order-list':
      break
    case 'address':
      utils.tracker('170101', '10000', 11022)
      break
    case 'experience':
      utils.tracker('140301', '10000', 11032)
      break
    default:
  }
}
